import {Crumb} from "src/view/commons/breadCrumb/breadcrumb_bar";

export const HomeCrumb:Crumb = {
    crumbLabel: "Home",
    crumbPath: "/"
}

export const DatasetCrumbs = (matchedParams: any, path: string): Crumb[] | null => {
    let crumbs: Crumb[] = [];
    if (path == "/datasets") {
        crumbs.push(HomeCrumb);
        crumbs.push({
            crumbLabel: "Datasets",
            crumbPath: "/datasets"
        })
    }
    
    return crumbs;
}

export const ConfigPanelCrumbs = (matchedParams: any, path: string): Crumb[] | null => {

    let crumbs: Crumb[] = []

    crumbs.push(HomeCrumb);

    let teamId = matchedParams.teamId;
    if (!teamId) {
        return null;
    }
    //TODO: Change this with Routes Map approach
    let isConfigView = path == "/configPanel/:teamId/namespaces/:namespaceId/configs/:configId/view"
    let isConfigEdit = path == "/configPanel/:teamId/namespaces/:namespaceId/configs/:configId/edit"
    let isConfigMerge = path == "/configPanel/:teamId/namespaces/:namespaceId/configs/:configId/merge"

    crumbs.push({
        crumbLabel: "Configuration Panel",
        crumbPath: `/configPanel/${teamId}/namespaces`
    });

    let namespaceId = matchedParams.namespaceId;
    let configId = matchedParams.configId;

    !namespaceId && crumbs.push({
        crumbLabel: "Namespaces",
        crumbPath: `/configPanel/${teamId}/namespaces`
    });


    namespaceId && crumbs.push({
        crumbLabel: `Namespace: ${namespaceId}`,
        crumbPath: `/configPanel/${teamId}/namespaces/${namespaceId}/configs`
    });

    namespaceId && !configId && crumbs.push({
        crumbLabel: "Configs",
        crumbPath: `/configPanel/${teamId}/namespaces/${namespaceId}/configs`
    });

    configId && crumbs.push({
        crumbLabel: `Config: ${configId}`,
        crumbPath: `/configPanel/${teamId}/namespaces/${namespaceId}/configs/${configId}/view`
    });

    configId && isConfigView && crumbs.push({
        crumbLabel: `View`,
        crumbPath: `/configPanel/${teamId}/namespaces/${namespaceId}/configs/${configId}/view`
    });

    configId && isConfigEdit && crumbs.push({
        crumbLabel: `Edit`,
        crumbPath: `/configPanel/${teamId}/namespaces/${namespaceId}/configs/${configId}/edit`
    });

    configId && isConfigMerge && crumbs.push({
        crumbLabel: `Merge`,
        crumbPath: `/configPanel/${teamId}/namespaces/${namespaceId}/configs/${configId}/merge`
    });

    return crumbs;
}

// TODO - change the routing to format - Routes.get(path) == "createNamespaceRoute"

export const FeatureGenerationCrumbs = (matchedParams: any, path: string): Crumb[] | null => {
    let crumbs: Crumb[] = []

    crumbs.push(HomeCrumb);

    let teamId = matchedParams.teamId;
    let namespaceId = matchedParams.namespaceId;

    if (!teamId) return null;

    crumbs.push({
        crumbLabel: "Feature Generation",
        crumbPath: `/featureGeneration/${teamId}/namespaces`
    });

    !namespaceId && crumbs.push({
        crumbLabel: "Namespaces",
        crumbPath: `/featureGeneration/${teamId}/namespaces`
    });

    !namespaceId && path.includes('new') && crumbs.push({
        crumbLabel: "Create Namespace",
        crumbPath: `/featureGeneration/${teamId}/namespaces/new`
    });

    namespaceId && crumbs.push({
        crumbLabel: `Namespace: ${namespaceId}`,
        crumbPath: `/featureGeneration/${teamId}/namespaces/${namespaceId}/view`
    });

    namespaceId && path.includes('view') && crumbs.push({
        crumbLabel: `View`,
        crumbPath: `/featureGeneration/${teamId}/namespaces/${namespaceId}/view`
    });

    namespaceId && path.includes('jobs') && crumbs.push({
        crumbLabel: "Jobs",
        crumbPath: `/featureGeneration/${teamId}/namespaces/${namespaceId}/jobs`
    });

    namespaceId && path.includes('jobs') && path.includes('new') && crumbs.push({
        crumbLabel: "Create Job",
        crumbPath: `/featureGeneration/${teamId}/namespaces/${namespaceId}/jobs`
    });

    return crumbs;
}

export const ModelTrainingCrumbs = (matchedParams: any, path: string): Crumb[] | null => {

    let crumbs: Crumb[] = []

    crumbs.push(HomeCrumb);

    let teamId = matchedParams.teamId;
    if (!teamId) {
        return null;
    }

    let namespaceId = matchedParams.namespaceId;
    let runwayId = matchedParams.runwayId;
    let version = matchedParams.version
    let experimentName = matchedParams.experimentName;

    crumbs.push({
        crumbLabel: "Model Training",
        crumbPath: `/modelTraining/${teamId}/namespaces`
    });

    !namespaceId && crumbs.push({
        crumbLabel: "Namespaces",
        crumbPath: `/modelTraining/${teamId}/namespaces`
    });

    !namespaceId && path.includes("create") && crumbs.push({
        crumbLabel: "Create Namespace",
        crumbPath: `/modelTraining/${teamId}/namespaces/create`
    });

    namespaceId && crumbs.push({
        crumbLabel: `Namespace: ${namespaceId}`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/view`
    });

    namespaceId && path.includes("view") && crumbs.push({
        crumbLabel: `View`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/view`
    });

    namespaceId && path.includes("runways") && crumbs.push({
        crumbLabel: `Runways`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways`
    });

    namespaceId && runwayId && version && path.includes("runways") && path.includes("update") && crumbs.push({
        crumbLabel: `Update Runway`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/${version}/update`
    });

    namespaceId && runwayId && path.includes("runways") && path.includes("view") && crumbs.push({
        crumbLabel: `View Runway`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/view`
    });

    namespaceId && runwayId && path.includes("runways") && path.includes("executions") && crumbs.push({
        crumbLabel: `Runway Executions`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/executions`
    });

    namespaceId && !runwayId && path.includes("runways") && path.includes("create") && crumbs.push({
        crumbLabel: `Create Runway`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/create`
    });

    namespaceId && runwayId && !path.includes("executions") && crumbs.push({
        crumbLabel: `Runway: ${runwayId}`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/experiments`
    });

    namespaceId && !version && !experimentName && !path.includes("create") && path.includes("experiments") && runwayId && crumbs.push({
        crumbLabel: `Experiments`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/experiments`
    });

    namespaceId && runwayId && experimentName && path.includes("edit") && crumbs.push({
        crumbLabel: `Edit: ${experimentName}`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/${experimentName}/edit`
    });

    namespaceId && path.includes("create") && runwayId && crumbs.push({
        crumbLabel: `Create Experiment`,
        crumbPath: `/modelTraining/${teamId}/namespaces/${namespaceId}/runways/${runwayId}/experiments/create`
    });

    return crumbs;
}
